<template>
  <div class="project-select">
    <h2>选择项目</h2>

    <van-radio-group v-model="selectedproject">
      <van-cell-group>
        <van-cell
          v-for="(item,i) in projects"
          :key="item.projectCode"
          :title="item.projectName"
          clickable
          @click="clickproject(item)"
        >
          <template #right-icon>
            <van-radio :name="item.projectCode" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>

<van-dialog v-model="show" title="选择模式" show-cancel-button @confirm="confirmMode" @cancel="cancelMode">
      <van-radio-group v-model="selectedMode">
      <van-cell-group>
        <van-cell
          v-for="(item,i) in Modes"
          :key="item.registryType"
          :title="item.registryName"
          clickable
          @click="clickMode(item)"
        >
          <template #right-icon>
            <van-radio :name="item.registryType" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
</van-dialog>



    <!-- 下一步按钮：只有选中了项目才可点击 -->
      <!--  -->
    <van-button
      type="primary"
      block
      style="margin-top: 30px;"
      :disabled="!selectedproject"
      @click="showDialog"
    >
      确 认
    </van-button>
  </div>
</template>

<script>
import req from '@/utils/request2.js';
export default {
  name: 'Selectproject',
  data() {
    return {
      selectedproject: '' || '', // 支持从 Vuex 恢复
      selectedData:{},
        projectList: [
				{ projectName: "引体向上", projectCode: "PullUp" },
				{ projectName: "立定跳远", projectCode: "Jump" },
				{ projectName: "坐位体前屈", projectCode: "SitAndReach" },
				{ projectName: "仰卧起坐", projectCode: "SitUp" },
				{ projectName: "体重/身高", projectCode: "HeightWeight" },
				{ projectName: "肺活量", projectCode: "VitalCapacity" },
				{ projectName: "50米", projectCode: "FiftyMeters" },
				{ projectName: "100米", projectCode: "HundredMeters" },
				{ projectName: "800米", projectCode: "EigthHunderMeters" },
				{ projectName: "1000米", projectCode: "ThousandMeters" },
				{ projectName: "耐力跑", projectCode: "Endurance" },
				// { projectName: "2000米", projectCode: "TThousandMeters" },
			],
      projects: [
    
    ],
    serveIp:"",
    outdoorRunnControlData:{},

    show:false,
    Modes:[],
    selectedMode:"",
      selectedModeData:{},

    }
  },
  watch: {
    // 一旦选中，立即提交到 Vuex（可选，也可在 goNext 时提交）
  
  },
  async mounted () {
    this.outdoorRunnControlData = JSON.parse(localStorage.getItem("outdoorRunnControlData"))
   await this.selectProjectToChangeByAreaId()
   await this.getProjectByAreaId()
  },
  methods: {
    async getProjectByAreaId(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getProjectByAreaId`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
        }).then(res=>{
          this.selectedproject = res.body.projectType
        })
    },

async getModelByProjectCodeAndAreaIdreq(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getModelByProjectCodeAndAreaId`,
          data:{
           projectCode:this.selectedproject,
          }
        }).then(res=>{
          console.log("sss",res);
          this.Modes = res.data


        })
    },
    async showDialog(){
      await this.getModelByProjectCodeAndAreaIdreq()
      this.show = true

    },
    clickMode(item){
      this.selectedMode  = item.registryType
      this.selectedModeData = item
    },
    async confirmMode(){
      if (this.selectedMode=="") {
        return this.$toast('请选择测试模式！！')
      }
     await this.changeProjectCodereq()
      console.log("confirmMode");
      
    },
    cancelMode(){
      console.log("cancelMode");

    },
    clickproject(item){
        this.selectedData = item
        this.selectedproject = item.projectCode
        console.log(item);
        
    },
    async selectProjectToChangeByAreaId(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/selectProjectToChangeByAreaId`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
        }).then(res=>{


          res.data?.forEach(el=>{
            this.projectList?.forEach(dl=>{
              if (el.projectCode==dl.projectCode) {
              this.$set(el,"projectName",dl.projectName)
              }
            })
          })
          this.projects = res.data||[]

          
          // if (this.projects.length>0) {
          //   this.selectedproject = this.projects[0].projectCode
          //   this.selectedData = this.projects[0]
          // }
          
        // this.$toast('操作成功');
        })
    },
      async changeProjectCodereq(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/changeProjectCode`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
           registryType:this.selectedMode,
           projectCode:this.selectedproject
          },
        }).then(res=>{
          if (res.status=="00") {
        this.$toast('操作成功');
          }else{
        this.$toast(res.msg);
          }
        })
    },
      async getModelByProjectCodeAndAreaId(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getModelByProjectCodeAndAreaId`,
          data:{
            projectCode:this.selectedproject
          },
        }).then(res=>{
          // this.projects = res.data||[]
          // if (this.projects.length>0) {
          //   this.selectedproject = this.projects[0].id
          //   this.selectedData = this.projects[0]
          // }
          
        // this.$toast('操作成功');
        })
    },
    goNext() {
      if (!this.selectedproject) {
        this.$toast('请选择一个项目')
        return
      }
      // outdoorRunnControlData outdoorRunnControlData

      this.$set(this.outdoorRunnControlData,"projectId",this.selectedData.projectCode)
      this.$set(this.outdoorRunnControlData,"projectName",this.selectedData.projectName)
      localStorage.setItem('outdoorRunnControlData',JSON.stringify(this.outdoorRunnControlData))
      
      this.$router.push('/outdoorRunning/DeviceStatus')
    }
  }
}
</script>

<style scoped>
.project-select {
  padding: 20px;
}
</style>